<div class="flex justify-content-between align-items-center gap-2 mt-4 w-full mb-4 flex-wrap">
  <span class="text-sm text-color-secondary">
    Si no tienes estudios académicos, haz clic en <strong>"No poseo estudios académicos"</strong>.
  </span>

  <div class="flex gap-2 justify-content-end w-full sm:w-auto">
    @if (dataSource().length === 0) {
    <button miButton="secondary" class="ml-auto sm:ml-0" [miButtonIcon]="'solar:info-circle-broken'" (click)="sinExperiencia()">
      No poseo estudios académicos
    </button>
    } @if (!indInexp) {
    <button miButton="primary" class="ml-auto sm:ml-0" [miButtonIcon]="'solar:add-circle-broken'" (click)="openModalCreate()">
      Agregar
    </button>
    }
  </div>
</div>

@if (!isMobile()) {
<app-mi-table-simple
  [dataSource]="dataSource()"
  [columns]="columns()"
  [displayedColumns]="displayedColumns()"
  [edit]="true"
  (editRow)="onEdit($event)"
  [delete]="true"
  (deleteRow)="onDelete($event)"
  [filterColumns]="filterColumns()"
>
</app-mi-table-simple>
} @else { @if (dataSource().length === 0) {

<!-- Estado vacío -->
<div class="flex flex-column align-items-center justify-content-center text-center p-4 border-round surface-card shadow-1 mb-3">
  <i class="iconify icon-32 mb-2 text-color-secondary" [attr.data-icon]="'solar:map-point-school-bold-duotone'"></i>
  <span class="text-lg font-bold mb-1">No hay información académica registrada</span>
  <span class="text-sm text-color-secondary mb-3">Agrega tu primer estudio académico para continuar.</span>
</div>

}@else {
<div class="grid">
  @for (item of dataSource(); track item.id) {
  <div class="col-12 mb-2">
    <article class="surface-card p-3 border-round shadow-1">
      <!-- Encabezado: Empresa + periodo + acciones -->
      <div class="flex justify-content-between align-items-start gap-2">
        <div class="flex align-items-start gap-3">
          <!-- Icono Empresa -->
          <div class="flex flex-column gap-1">
            <div class="flex items-center gap-2">
              <i class="iconify mt-1 icon-18" [attr.data-icon]="'solar:map-point-school-bold-duotone'" aria-hidden="true"></i>
              <span class="font-bold text-xl"> {{ item.institucion | titlecase }} </span>
            </div>
            @if (item.periodo) {
            <div class="flex items-center gap-2">
              <i class="iconify mt-1 icon-18" [attr.data-icon]="'solar:calendar-bold-duotone'" aria-hidden="true"></i>
              <small class="text-sm">{{ item.periodo }}</small>
            </div>
            }
            <div class="flex items-center gap-2">
              <i class="iconify mt-1 icon-18" [attr.data-icon]="'solar:document-bold-duotone'" aria-hidden="true"></i>
              <small class="text-sm">{{ item.programa | titlecase }}</small>
            </div>
          </div>
        </div>

        <!-- Acciones a la derecha (icon-only) -->
        <div class="flex align-items-center gap-2">
          <!-- Editar -->
          <button
            miButton="secondary"
            [miButtonIcon]="'solar:pen-bold-duotone'"
            class="mi-button-icon-only"
            aria-label="Editar"
            (click)="onEdit(item)"
          ></button>

          <!-- Eliminar -->
          <button
            miButton="danger"
            [miButtonIcon]="'solar:trash-bin-trash-broken'"
            class="mi-button-icon-only"
            aria-label="Eliminar"
            (click)="onDelete(item)"
          ></button>
        </div>
      </div>
    </article>
  </div>
  }
</div>
} }
